import moment from 'moment'
import store from '@/store'

/*
{
	"calendarPickerLocale": {
		"days": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
		"daysShort": ["Sun", "Mon", "Tues", "Wed", "Thu", "Fri", "Sat"],
		"months": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
		"monthsShort": ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
		"firstDayOfWeek": 1,
		"flag": "gb",
		"key": "en-GB",
		"name": "English (en-GB)"
	},
	"definition": {
		"hourPeriods": [{
			"am": "morning"
		}, {
			"pm": "afternoon"
		}],
		"timeFormat": "12",
		"hourFormat": "HH:mm",
		"dateFormat": "MM/DD/YYYY",
		"decimalSeparator": ",",
		"groupSeparator": "",
		"maskNumber": "######,##"
	}
}
*/

export default {
    locale() {
        return store.getters['locale/currentLocale']
    },

    fromServerToVDatePicker(date) {
        return this.fromServerToUxString(date, 'date', 'YYYY-MM-DD')
    },

    /**
     * Convert @date value into requested @formatType (which must exist in the locales definition)
     * @param {*} date The date value to convert
     * @param {*} formatType The format to use
     * @returns
     */
    fromDatePickerToUxDate(date, formatType = 'date') {
        moment.locale(this.locale().key)
        let localFormat = this.locale().definition.dateFormat

        if (formatType === 'dateTime') {
            return moment(date).format(this.locale().definition.hourFormat)
        } else if (formatType === 'fullTime') {
            return moment(date).format(
                this.locale().definition.dateFormat +
                    ' ' +
                    this.locale().definition.hourFormat
            )
        } else if (formatType === 'day') {
            return moment(date).format('dddd')
        } else if (formatType === 'descriptionDate') {
            return moment(date).format('MMMM d' + ', ' + 'YYYY')
        } else {
            return moment(date).format(localFormat)
        }
    },

    getDateMask() {
        return this.locale().definition.dateFormat
    },

    getDateTimeMask() {
        return this.locale().definition.hourFormat
    },

    getFullTimeMask() {
        return (
            this.locale().definition.dateFormat +
            ' ' +
            this.locale().definition.hourFormat
        )
    },

    /**
     * Convert @date value into server format
     * @param {*} date The date value to convert
     * @param {*} formatType
     * @param {*} withOffSet
     * @returns
     */
    fromUxToServer(date, formatType = 'date') {
        moment.locale(this.locale().key)

        let localFormat =
            formatType === 'date'
                ? this.locale().definition.dateFormat
                : formatType === 'dateTime'
                ? this.locale().definition.dateFormat +
                  ' ' +
                  this.locale().definition.hourFormat
                : this.locale().definition.hourFormat

        let dateToServer = moment(date, localFormat).utc()

        if (formatType == 'date') {
            dateToServer.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        }

        return dateToServer.format('YYYY-MM-DD HH:mm:ss')
        // let dateNoOffset = moment(date, localFormat)
        // let dateWithOffet = dateNoOffset.clone()
        // let dateUtc = dateNoOffset
        //     .clone()
        //     .utcOffset(dateWithOffet.utcOffset() * -1)

        // if (withOffSet == false) {
        //     return dateNoOffset.format('YYYY-MM-DD HH:mm:ss')
        // }

        // dateUtc.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        // return dateUtc.format('YYYY-MM-DD HH:mm:ss')
    },

    fromUxTimeToServer(date) {
        return this.fromUxToServer(date, 'time')
    },

    fromUxDateToServer(date, withOffSet = false) {
        return this.fromUxToServer(date, 'date', withOffSet)
    },

    fromUxDateTimeToServer(date) {
        return this.fromUxToServer(date, 'dateTime')
    },

    fromServerToUxTime(date) {
        return this.fromServerToUxString(date, 'time')
    },

    fromServerToUxDate(date) {
        return this.fromServerToUxString(date, 'date')
    },

    fromServerToUxDateTime(date) {
        return this.fromServerToUxString(date, 'dateTime')
    },

    fromServerToUxString(date, formatType = 'date', customFormat = null) {
        moment.locale(this.locale().key)
        if (!date || isNaN(new Date(date).getTime())) {
            return
        }

        // let locale = return store.getters['locale/currentLocale']

        let format =
            formatType === 'date'
                ? this.locale().definition.dateFormat
                : formatType === 'dateTime'
                ? this.locale().definition.dateFormat +
                  ' ' +
                  this.locale().definition.hourFormat
                : formatType === 'fullTime'
                ? this.locale().definition.dateFormat +
                  ' ' +
                  this.locale().definition.hourFormat
                : this.locale().definition.hourFormat

        return moment(String(date)).format(customFormat ?? format)
    },

    fromServerToJsDate(date) {
        moment.locale(this.locale().key)
        return moment(date).toDate()
    },

    getDifferenceDays(lastDate, beginDate = null) {
        var startDate = beginDate ? new moment(beginDate) : moment(new Date())
        var endDate = new moment(lastDate)

        var duration = moment.duration(startDate.diff(endDate))
        var days = duration.asDays()
        if (Math.round(Math.abs(days)) > 0) {
            return Math.round(Math.abs(days))
        }

        var hours = duration.asHours()

        if (Math.round(Math.abs(hours)) > 0) {
            return Math.round(Math.abs(hours))
        }

        var minutes = duration.asMinutes()

        if (Math.round(Math.abs(minutes)) > 0) {
            return Math.round(Math.abs(minutes))
        }

        return Math.round(Math.abs(duration.asSeconds()))
    },

    checkDate(beginDate, endDate) {
        var startDate = new moment(beginDate, 'DD-MM-YYYY')
        var lastDate = new moment(endDate, 'DD-MM-YYYY')
        var duration = moment.duration(startDate.diff(lastDate))
        if (duration._data.days > 0) {
            return false
        }
        return true
    },
}
